"use strict"

import { renderEvents } from "./renderEvents.js";

const movieContainer = document.querySelector(".movie-container");

let currentPage;

const createEventPagination = (arr, page, start = 'Start', end = 'Ende', next = 'Weiter', back = 'Zurück') => {
    
    const paginationContainer = document.createElement('div');
    paginationContainer.className = "pagination-container";

    const pageNumbers = document.createElement('div');
    pageNumbers.className = "page-numbers";

    currentPage = page;

    let maxItems = 10;
    let pageCount = Math.ceil(arr.length / maxItems);
    
    const startBtn = document.createElement('button');
    startBtn.className = "label-btn start";
    startBtn.textContent = start;

    const firstPage = () => {
        currentPage = 1;
        movieContainer.replaceChildren(renderEvents(arr, 1));
        let currentButton = document.querySelector('.btn-active');
        currentButton.classList.remove('btn-active');
        currentButton.disabled = false;
        let firstPageButton = document.querySelectorAll('.page-btn')[0];
        firstPageButton.classList.add('btn-active');

        startBtn.disabled = true;
        backBtn.disabled = true;
        nextBtn.disabled = false;
        endBtn.disabled = false;

        window.scrollTo(0, 0, 'smooth');
    }
    paginationContainer.appendChild(startBtn);
    startBtn.addEventListener('click', firstPage);
    startBtn.disabled = true;

    const backBtn = document.createElement('button');
    backBtn.className = "label-btn back";
    backBtn.textContent = back;

    const previousPage = () => {

        currentPage = currentPage - 1;


        movieContainer.replaceChildren(renderEvents(arr, currentPage));
        let currentButton = document.querySelector('.btn-active');
        currentButton.classList.remove('btn-active');
        currentButton.disabled = false;

        let newActiveButton = document.querySelectorAll('.page-btn')[currentPage - 1];

        newActiveButton.classList.add('btn-active');
        newActiveButton.disabled = true;
        nextBtn.disabled = false;
        endBtn.disabled = false;
        if(currentPage == 1) {
            startBtn.disabled = true;
            backBtn.disabled = true;
        }
        scrollToTop();
    };
    paginationContainer.appendChild(backBtn);
    backBtn.addEventListener('click', previousPage);
    backBtn.disabled = true;



    const nextBtn = document.createElement('button');
    nextBtn.className = "label-btn next";
    nextBtn.textContent = next;

    const nextPage = () => {
        
        // muss richtig sein 
        currentPage = currentPage + 1;

        movieContainer.replaceChildren(renderEvents(arr, currentPage));
        let currentButton = document.querySelector('.btn-active');
        currentButton.classList.remove('btn-active');
        currentButton.disabled = false;

        let newActiveButton = document.querySelectorAll('.page-btn')[currentPage - 1];

        newActiveButton.classList.add('btn-active');
        newActiveButton.disabled = true;

        startBtn.disabled = false;
        backBtn.disabled = false;

        if(currentPage == pageCount) {
        nextBtn.disabled = true;
        endBtn.disabled = true;
        }
        scrollToTop();
    }
    paginationContainer.appendChild(nextBtn);
    nextBtn.addEventListener('click', nextPage);



    const endBtn = document.createElement('button');
    endBtn.className = "label-btn end";
    endBtn.textContent = end;

    const lastPage = () => {
        currentPage = pageCount;
        movieContainer.replaceChildren(renderEvents(arr, currentPage));
        let currentButton = document.querySelector('.btn-active');
        currentButton.classList.remove('btn-active');
        currentButton.disabled = false;
        let lastPageButton = document.querySelectorAll('.page-btn')[currentPage - 1];
        lastPageButton.classList.add('btn-active');

        nextBtn.disabled = true;
        endBtn.disabled = true;

        startBtn.disabled = false;
        backBtn.disabled = false;

        scrollToTop();
    }
    paginationContainer.appendChild(endBtn);
    endBtn.addEventListener('click', lastPage);

    for (let i = 1; i < pageCount + 1; i++) {
        let btn = PaginationButton(arr, i, startBtn, backBtn, nextBtn, endBtn, pageCount)
        pageNumbers.appendChild(btn);
        
    }
    paginationContainer.appendChild(pageNumbers);
    return paginationContainer;
}

const PaginationButton = (arr, page, startBtn, backBtn, nextBtn, endBtn, pageCount) => {

    let pageButton = document.createElement('button');
    pageButton.textContent = page;
    pageButton.className = "page-btn";
    if (currentPage === page) pageButton.classList.add('btn-active');
    pageButton.addEventListener('click', () => {

        scrollToTop();
        currentPage = page;
        console.log(currentPage);

        if (currentPage === 1) {
            startBtn.disabled = true;
            backBtn.disabled = true;
        } 
        if (currentPage > 1) {
            startBtn.disabled = false;
            backBtn.disabled = false;
        } 
        if (currentPage === pageCount) {
            nextBtn.disabled = true;
            endBtn.disabled = true;
        } 
        if (currentPage < pageCount) {
            nextBtn.disabled = false;
            endBtn.disabled = false;
        }
        
        movieContainer.replaceChildren(renderEvents(arr, currentPage));

        let currentButton = document.querySelector('.btn-active');
        currentButton.classList.remove('btn-active');
        currentButton.disabled = false;

        if (currentPage) {
            let newPageButton = pageButton;
            newPageButton.classList.add('btn-active');
            console.log(newPageButton);
            newPageButton.disabled = true;
        } 
   
    })
    return pageButton;
}

const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
}

export { createEventPagination };